import type { IKompisTranslations } from '@inter-ikea-kompis/types';
import type { IStorageTwoTranslations } from './state/translations/translationsTypes';

interface IKompisTranslationMappings {
  [key: string]: keyof IKompisTranslations;
}

interface IStorageTwoTranslationMappings {
  [key: string]: keyof IStorageTwoTranslations;
}

export interface ITranslationMappings {
  [key: string]: keyof (IKompisTranslations & IStorageTwoTranslations);
}

const kompisTranslationMappings: IKompisTranslationMappings = {
  BACK: 'back',
  DONE: 'done',
  INFORMATION_VIEW_MORE_INFORMATION: 'informationViewMoreInformation',
  INVALID_CONFIGURATION_DESCRIPTION: 'invalidConfigurationDescription',
  INVALID_CONFIGURATION_MESSAGE: 'invalidConfigurationMessage',
  IPEX_GALLERY_EXIT_DIALOGUE_BODY: 'ipexGalleryExitDialogueBody',
  IPEX_GALLERY_EXIT_DIALOGUE_CONTINUE_BUTTON:
    'ipexGalleryExitDialogueContinueButton',
  IPEX_GALLERY_EXIT_DIALOGUE_EXIT_BUTTON: 'ipexGalleryExitDialogueExitButton',
  IPEX_GALLERY_EXIT_DIALOGUE_HEADLINE: 'ipexGalleryExitDialogueHeadline',
  LABEL_DEPTH: 'labelDepth',
  LABEL_HEIGHT: 'labelHeight',
  LABEL_WIDTH: 'labelWidth',
  LOAD_VPC_DIALOG_HEADING: 'loadVpcDialogHeading',
  MEASURE_VALUE_CM: 'measureValueCm',
  MEASURE_VALUE_IN: 'measureValueIn',
  MEASURE_VALUE_FEET: 'measureValueFeet',
  PLANNER_BANNER_MESSAGE_BODY: 'plannerBannerMessageBody',
  PLANNER_BANNER_MESSAGE_BODY_KIOSK: 'plannerBannerMessageBodyKiosk',
  PLANNER_BANNER_MESSAGE_LINK_TEXT: 'plannerBannerMessageLinkText',
  PLANNER_BANNER_MESSAGE_TITLE: 'plannerBannerMessageTitle',
  PLANNER_BANNER_MESSAGE_TITLE_KIOSK: 'plannerBannerMessageTitleKiosk',
  PLANNER_SURVEY_DECLINE: 'plannerSurveyDecline',
  PRODUCT_DETAILS_GOOD_TO_KNOW_HEADER: 'productDetailsGoodToKnowHeader',
  PRODUCT_DETAILS_SAFETY_AND_COMPLIANCE_HEADER:
    'productDetailsSafetyAndComplianceHeader',
  PRODUCT_LIST_HEADLINE: 'productListHeadline',
  SERIES_GALLERY_LINK: 'seriesGalleryLink',
  SHORT_LABEL_DEPTH: 'shortLabelDepth',
  SHORT_LABEL_HEIGHT: 'shortLabelHeight',
  SHORT_LABEL_WIDTH: 'shortLabelWidth',
  SPR_GALLERY_HEADLINE: 'sprGalleryHeadline',
  SPR_GALLERY_OPEN_SAVED_SPR: 'sprGalleryOpenSavedSpr',
  START_AGAIN: 'startAgain',
  START_FROM_SCRATCH: 'startFromScratch',
  TIMES_SYMBOL: 'timesSymbol',
  TIP_OVER_WARNING: 'tipOverWarning',
  TIP_OVER_WARNING_LINK: 'tipOverWarningLink',
  TOOLTIP_DELETE: 'tooltipDelete',
  TOOLTIP_DELETE_SECTION: 'tooltipDeleteSection',
  TOOLTIP_INFO: 'tooltipInfo',
  TOOLTIP_ROTATE: 'tooltipRotate',
  YES_PLEASE: 'yesPlease',
  YMAL_HEADING: 'ymalHeading',
};

const storageTwoTranslationMappings: IStorageTwoTranslationMappings = {
  ALERT_INFORMATION_CLOTHES_RAIL: 'alertInformationClothesRail',
  AURDAL_DRAWERS_GOOD_TO_KNOW_DESCRIPTION: 'aurdalDrawersGoodToKnowDescription',
  AURDAL_DRAWERS_GOOD_TO_KNOW_HEADING: 'aurdalDrawersGoodToKnowHeading',
  BACK_TO_PRODUCT_GALLERY: 'backToProductGallery',
  BALLOON_HINT_NO_PLACE: 'balloonHintNoPlace',
  BALLOON_HINT_STEP_THREE_UNIT: 'balloonHintStepThreeUnit',
  BALLOON_HINT_STEP_THREE_WALL_INTRO: 'balloonHintStepThreeWallIntro',
  BRACKETS_INFO: 'bracketsInfo',
  BUTTON_HIDE_MEASURES: 'buttonHideMeasures',
  BUTTON_SHOW_MEASURES: 'buttonShowMeasures',
  CANNOT_FIT_CABINET: 'cannotFitCabinet',
  CANNOT_FIT_SHELF_DIVIDER: 'cannotFitShelfDivider',
  CEILING_HEIGHT: 'ceilingHeight',
  CHOICE_INFORMATION: 'choiceInformation',
  CLOTHES_RAIL_ADJACENT: 'clothesRailAdjacent',
  COLOUR: 'colour',
  FILTER_DEPTH_LABEL: 'filterDepthLabel',
  GALLERY_RETURN_INFORMATION: 'galleryReturnInformation',
  LINK_CARD_SKYTTA_BUTTON: 'linkCardSkyttaButton',
  LINK_CARD_SKYTTA_DESCRIPTION: 'linkCardSkyttaDescription',
  LINK_CARD_SKYTTA_HEADING: 'linkCardSkyttaHeading',
  MENU_FILTER_ACCESSORIES: 'menuFilterAccessories',
  MENU_FILTER_CABINETS: 'menuFilterCabinets',
  MENU_FILTER_INSERTS: 'menuFilterInserts',
  MENU_FILTER_ONE: 'menuFilterOne',
  MENU_FILTER_TABLETOP: 'menuFilterTabletop',
  MENU_FILTER_THREE: 'menuFilterThree',
  MENU_FILTER_TWO: 'menuFilterTwo',
  MENU_FILTER_UPRIGHTS: 'menuFilterUprights',
  MENU_PRODUCT_DOORS: 'menuProductDoors',
  MENU_SECTION_FRAMES: 'menuSectionFrames',
  MENU_SECTION_SHELVING_UNITS: 'menuSectionShelvingUnits',
  MINI_SURVEY_BODY: 'miniSurveyBody',
  MOUNTING_RAIL: 'mountingRail',
  MOUNTING_RAIL_COMES_IN_THREE_DIFFERENT_LENGTHS:
    'mountingRailComesInThreeDifferentLengths',
  MOUNTING_RAIL_CUT: 'mountingRailCut',
  MOUNTING_RAIL_HELPS_YOU_HANG_STORAGE_RAILS_EVENLY:
    'mountingRailHelpsYouHangStorageRailsEvenly',
  POPUP_ADD_SHELVES_BODY: 'popupAddShelvesBody',
  POPUP_ADD_SHELVES_HEADER: 'popupAddShelvesHeader',
  POPUP_ALERT_DUPLICATE_SIDEPANEL: 'popupAlertDuplicateSidepanel',
  POPUP_ALERT_INVALID_CONFIG_ADD_PART: 'popupAlertInvalidConfigAddPart',
  POPUP_ALERT_INVALID_CONFIG_HIGH_CABINET: 'popupAlertInvalidConfigHighCabinet',
  POPUP_ALERT_INVALID_CONFIG_LOW_SECTION: 'popupAlertInvalidConfigLowSection',
  POPUP_ALERT_INVALID_CONFIG_MISPLACED: 'popupAlertInvalidConfigMisplaced',
  POPUP_ALERT_INVALID_CONFIG_PLACEMENT: 'popupAlertInvalidConfigPlacement',
  POPUP_ALERT_INVALID_CONFIG_WEIGHT: 'popupAlertInvalidConfigWeight',
  POPUP_ALERT_SUSPENSION_RAIL: 'popupAlertSuspensionRail',
  POPUP_INFORMATION_DOORS: 'popupInformationDoors',
  POPUP_MENU_HEADER_BASKETS: 'popupMenuHeaderBaskets',
  POPUP_MENU_HEADER_FRAME: 'popupMenuHeaderFrame',
  POPUP_MENU_HEADER_INSERTS: 'popupMenuHeaderInserts',
  POPUP_MENU_HEADER_SECTION: 'popupMenuHeaderSection',
  POPUP_PEGBOARD_HINT: 'popupPegboardHint',
  POSTS: 'posts',
  POST_MOUNTING_INFO: 'postMountingInfo',
  PRODUCT_INFO_SHEET: 'productInfoSheet',
  PRODUCT_INFO_SHEET_DESCRIPTION: 'productInfoSheetDescription',
  REPLACE_PREVIOUS_BODY: 'replacePreviousBody',
  REPLACE_PREVIOUS_HEADING: 'replacePreviousHeading',
  REPLACE_PREVIOUS_PRIMARY: 'replacePreviousPrimary',
  REPLACE_PREVIOUS_SECONDARY: 'replacePreviousSecondary',
  SAFETY_AND_COMPLIANCE_DESCRIPTION: 'safetyAndComplianceDescription',
  SCREENSAVER_TEXT: 'screensaverText',
  SELECT_BASE: 'selectBase',
  SIDE_UNITS: 'sideUnits',
  SIDE_UNIT_INFO: 'sideUnitInfo',
  SPLASH_SCREEN_STEP_FOUR_DESCRIPTION: 'splashScreenStepFourDescription',
  TOASTER_ARTICLE_EXCHANGED: 'toasterArticleExchanged',
  TOASTER_PEGBOARD_INFO: 'toasterPegboardInfo',
  TOASTER_PEGBOARD_KIOSK: 'toasterPegboardKiosk',
  TOASTER_RESET_WALL: 'toasterResetWall',
  TOAST_ADD_SHELVES: 'toastAddShelves',
  TOAST_MULTIPACK_INFO: 'toastMultipackInfo',
  TOOLTIP_ADD_CABINET: 'tooltipAddCabinet',
  TOOLTIP_ADD_CASTORS: 'tooltipAddCastors',
  TOOLTIP_ADD_COVER: 'tooltipAddCover',
  TOOLTIP_ANTHRACITE: 'tooltipAnthracite',
  TOOLTIP_BAMBOO: 'tooltipBamboo',
  TOOLTIP_BLACK: 'tooltipBlack',
  TOOLTIP_BLACKBROWN: 'tooltipBlackbrown',
  TOOLTIP_BLACK_MESH: 'tooltipBlackMesh',
  TOOLTIP_DARK_GREY: 'tooltipDarkGrey',
  TOOLTIP_FILTER_HINT: 'tooltipFilterHint',
  TOOLTIP_GREEN_MESH: 'tooltipGreenMesh',
  TOOLTIP_GREY: 'tooltipGrey',
  TOOLTIP_GREY_GREEN: 'tooltipGreyGreen',
  TOOLTIP_GREY_GREEN_MESH: 'tooltipGreyGreenMesh',
  TOOLTIP_GREY_MESH: 'tooltipGreyMesh',
  TOOLTIP_LIGHT_BLUE: 'tooltipLightBlue',
  TOOLTIP_MESH: 'tooltipMesh',
  TOOLTIP_MESH_ANTHRACITE: 'tooltipMeshAnthracite',
  TOOLTIP_METAL: 'tooltipMetal',
  TOOLTIP_OAK_PATTERNED: 'tooltipOakPatterned',
  TOOLTIP_PINE: 'tooltipPine',
  TOOLTIP_RED: 'tooltipRed',
  TOOLTIP_REDO: 'tooltipRedo',
  TOOLTIP_REMOVE_CABINET: 'tooltipRemoveCabinet',
  TOOLTIP_REMOVE_CASTORS: 'tooltipRemoveCastors',
  TOOLTIP_REMOVE_COVER: 'tooltipRemoveCover',
  TOOLTIP_TEXTILE: 'tooltipTextile',
  TOOLTIP_TYPE_MESH: 'tooltipTypeMesh',
  TOOLTIP_TYPE_PARTICLEBOARD: 'tooltipTypeParticleboard',
  TOOLTIP_TYPE_WIRE: 'tooltipTypeWire',
  TOOLTIP_UNDO: 'tooltipUndo',
  TOOLTIP_WALL_MEASUREMENTS: 'tooltipWallMeasurements',
  TOOLTIP_WHITE: 'tooltipWhite',
  TOOLTIP_WHITE_OAK: 'tooltipWhiteOak',
  TOOLTIP_WIRE_SHELF: 'tooltipWireShelf',
  TOOLTIP_WOOD: 'tooltipWood',
  TYPE: 'type',
  USE_POSTS: 'usePosts',
  USE_SIDE_UNITS: 'useSideUnits',
};

export const t: ITranslationMappings = {
  ...kompisTranslationMappings,
  ...storageTwoTranslationMappings,
};
